var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"u__img",attrs:{"src":_vm.src,"alt":_vm.src},on:{"click":_vm.clickHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }